import {getCurrentYear} from '../../utils/commons'
import BestHomeCleaningPicksLogo from './logo'
import {bestHomeCleaningPicksUS} from './styles'

const baseConfig = {
  domainName: 'besthomecleaningpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Home Cleaning Picks',
  logo: <BestHomeCleaningPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/besthomecleaningpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-SX4JSP38TZ',
    camelCaseUrl: 'BestHomeCleaningPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestHomeCleaningPicks.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Find the best vacuum cleaners with expert reviews and comparisons. From robot vacuums to powerful uprights, upgrade your cleaning routine with trusted picks.`,
    styles: bestHomeCleaningPicksUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
